module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow-be4d86e29ceb8c1319980b2c78bc9209.png";